import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Depositservice extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="depositservice" className="a-breadcrumbs">บริการด้านเงินฝาก</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{fontFamily: '"Cordia New"',fontSize: 20}}>
                <h2 className="title-section mt-0 mb-0"><span>บริการด้านเงินฝาก</span></h2><br/>
                <div className="divider gray left mt-20 mb-25" />
                <h3>บริการเงินฝาก</h3>
                <p className="mb-20">หากพนักงานต้องการเปิดบัญชีของสหกรณ์จะต้องเป็นสมาชิกของสหกรณ์ก่อนจึงจะสามารถเปิดบัญชีของสหกรณ์ได้ ซึ่งทางสหกรณ์ มีบัญชี 3 ประเภทดังนี้</p>
                <ul className="mb-25">
                  <li>1. <u>บัญชีออมทรัพย์</u> อัตราดอกเบี้ย 1.00% ต่อปี  เปิดบัญชีขั้นต่ำ 100 บาท</li>
                  <li>2. <u>บัญชีฝากประจำ 6 เดือน</u> อัตราดอกเบี้ย 1.75% ต่อปี  เปิดบัญชีขั้นต่ำ 100 บาท</li>
                  <li>3. <u>บัญชีฝากประจำ 12 เดือน</u> อัตราดอกเบี้ย 2.25% ต่อปี  เปิดบัญชีขั้นต่ำ 100 บาท</li>
                  <li>4. บัญชีออมทรัพย์พิเศษ อัตราดอกเบี้ย 2.50% ต่อปี</li>
                  <li>4.1 เปิดบัญชีขั้นต่ำ 100 บาท</li>
                  <li>4.1 ที่มาของเงินฝาก</li>
                  <li>4.1.1 เงินค่าหุ้นเนื่องจากลาออกและสมัครกลับเข้ามาเป็นสมาชิกใหม่ในคราวเดียวกัน</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;- ฝากได้ไม่เกิน (มูลค่าหุ้นที่มีอยู่ก่อนลาออกหักด้วยจำนวนเงินที่ชำระต่อสหกรณ์เรียบร้อยแล้ว)</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;- สมาชิกจะต้องดำเนินการฝากเงินให้แล้วเสร็จภายใน 30 วัน นับตั้งแต่วันที่ได้รับเงินดังกล่าว</li>
                  <li>4.1.2 เงินได้ในโอกาสเกษียณอายุ (ไม่รวมเงินได้จากการชดเชยวันหยุดงานพักผ่อนประจำปีและวันหยุดอื่นที่หน่วยงานต้นสังกัดจ่ายให้ เนื่องด้วยมิได้ใช้ตามสิทธิ)</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;- ฝากได้ไม่เกิน (ตามที่ได้รับจริงหักด้วยจำนวนเงินที่ซื้อหุ้นเพิ่ม)</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;- สมาชิกจะต้องดำเนินการฝากเงินให้แล้วเสร็จภายใน 30 วัน นับตั้งแต่วันที่ได้รับเงินดังกล่าว</li>
                  <li>4.1.3 เงินกองทุนสำรองเลี้ยงชีพ เมื่อเกษียณอายุ</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;- ฝากได้ไม่เกิน (ตามที่ได้รับจริงหักด้วยจำนวนเงินที่ซื้อหุ้นเพิ่ม)</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;- สมาชิกจะต้องดำเนินการฝากเงินให้แล้วเสร็จภายใน 6 เดือน นับตั้งแต่วันที่เกษียณอายุมีผล</li>
                  <li>4.2 จำนวนเงินฝากเมื่อรวมกับมูลค่าหุ้นทั้งหมดที่มีอยู่กับสหกรณ์  ต้องไม่เกิน 30,000,000 บาท (สามสิบล้านบาทถ้วน) และสมาชิกจะต้องดำเนินการฝากเงินประเภทออมทรัพย์พิเศษให้แล้วเสร็จภายในคราวเดียวสำหรับเงินได้แต่ละประเภท</li>
                </ul>
                <h3>เงื่อนไขในการถอน</h3>
                <ul className="mb-25">
                  <li>1. ถอนเงินสดได้ไม่เกิน 100,000 บาทต่อวัน</li>
                  <li>2. ถอนได้วันละ 2 ครั้ง (ตามหมายเลขสมาชิก)</li>
                  <li>3. หากถอนเกิน 100,000 บาท รับเงินโดยโอนเข้าบัญชีธนาคารตามที่สมาชิกแจ้ง</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;3.1 รับเงินผ่านธนาคารไทยพาณิชย์และทหารไทยได้รับเงินเข้าบัญชีในวันเดียวกัน หลัง 17.00 น.</li>
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;3.2 รับเงินผ่านธนาคารอื่นๆได้รับเงินเข้าบัญชีภายใน 2 วันทำการถัดไป</li>
                  <li>3. บัญชีออมทรัพย์ต้องคงเหลือเงินไว้ขั้นต่ำ 10 บาท</li>
                  <li>4. บัญชีฝากประจำต้องคงเหลือเงินไว้ขั้นต่ำ 100 บาท</li>
                </ul>
                <h3>ขั้นตอนการถอนเงินฝากบัญชีออมทรัพย์สหกรณ์ (ของสมาชิก) ผ่านบัตร ATM ธนาคารกรุงศรี</h3>
                <ul className="mb-25">
                  <li>ติดต่อเปิดบัญชีออมทรัพย์ธนาคารกรุงศรีพร้อมบัตร ATM สำหรับใช้กับสหกรณ์ <u><a href="Form/รายละเอียดติดต่อเปิดบัญชีกรุงศรี.pdf" target="_blank" style={{color: '#4db6f1'}}>คลิกใบนำส่งเปิดบัญชี</a></u></li>
                  <li>กรอกบันทึกข้อตกลงถอนเงินฝากบัญชีผ่านช่องทางอิเล็กทรอนิกส์ของธนาคารกรุงศรี เพื่อระบุวงเงินถอนผ่านบัตร ATM ต่อวัน</li>
                  <li>เมื่อเปิดบัญชีพร้อมบัตร ATM ธนาคารกรุงศรีแล้ว กรอกแบบฟอร์มข้อตกลงถอนเงินฝาก พร้อมถ่ายสำเนาหน้าสมุดบัญชีกรุงศรี ส่งกลับมาให้สหกรณ์</li>
                  <li>เมื่อสหกรณ์ดำเนินการเรียบร้อยจะแจ้งสมาชิกทาง E-mail</li>
                </ul>
                <h3>เงื่อนไขการถอน บัญชีออมทรัพย์พิเศษ</h3>
                <ul className="mb-25">
                  <li>1. ถอนได้ 4 ครั้งต่อปี ไม่มีค่าธรรมเนียม  ครั้งถัดไป มีค่าธรรมเนียม 200 บาทต่อครั้ง</li>
                </ul>
                <h3>การถอนเงินฝากผ่านบัตร ATM</h3><br/>
                <div className="row">
                  <div className="col-md-9 col-sm-9 mb-sm-50">
                    <div className="divider gray left mt-20 mb-25" />
                    <img src="Img/WithDrawATM/atm.JPG" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Depositservice;
